import { useSearchParams } from 'react-router-dom';
import { CustomerSearch } from 'src/components/CustomerSearch';
import { DriverDetailView } from 'src/scenes/Driver/DriverDetailView';

export const DriverSearch = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const customerNumber = searchParams.get('customerNumber');

  if (customerNumber) {
    return <DriverDetailView customerNumber={customerNumber} onCancel={() => setSearchParams({})} />;
  }

  return <CustomerSearch onSelectCustomer={(customerNumber: string) => setSearchParams({ customerNumber })} />;
};

if (module.hot) {
  module.hot.accept();
}
